import SidebarPusher from 'client/common/components/sidebar-pusher';

import './index.css';

export default SidebarPusher;
